import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import React from 'react';
import { Text, TouchableWithoutFeedback, View, Platform } from 'react-native';
import TitleArrow from './TitleArrow';
export var TitleLabel = function TitleLabel(_ref) {
  var label = _ref.label,
    styles = _ref.styles;
  var style = _objectSpread({
    fontWeight: 'bold',
    fontSize: 16
  }, styles === null || styles === void 0 ? void 0 : styles.label);
  return /*#__PURE__*/React.createElement(Text, {
    style: style
  }, label);
};
export var containerStyle = function containerStyle(styles, width, headerStyle) {
  var style = _objectSpread({
    flex: 1,
    flexDirection: 'row',
    alignContent: 'center',
    paddingVertical: 10,
    paddingHorizontal: 4
  }, styles === null || styles === void 0 ? void 0 : styles.container);
  if (width) {
    style.flex = 0;
    style.flexBasis = width;
  }
  if ('web' === Platform.OS) {
    style.paddingTop = style.paddingVertical;
    style.paddingBottom = style.paddingVertical;
    style.paddingLeft = style.paddingHorizontal;
  }
  return _objectSpread(_objectSpread({}, style), headerStyle);
};
var Title = function Title(props) {
  var styles = props.styles,
    updateOrder = props.updateOrder,
    width = props.width,
    htmlTable = props.htmlTable,
    headerStyle = props.headerStyle,
    sortOnArrowClickOnly = props.sortOnArrowClickOnly,
    key = props.columnKey;
  var style = containerStyle(styles, width, headerStyle);
  var updateOrderWeb = function updateOrderWeb(key, e) {
    if (!sortOnArrowClickOnly) {
      updateOrder(key, e.shiftKey || e.metaKey);
    }
  };
  var updateOrderNative = function updateOrderNative(key) {
    if (!sortOnArrowClickOnly) {
      updateOrder(key, true);
    }
  };
  if (htmlTable) {
    return /*#__PURE__*/React.createElement("th", {
      style: style,
      onClick: function onClick(e) {
        return updateOrderWeb(key, e);
      }
    }, /*#__PURE__*/React.createElement(TitleLabel, props), /*#__PURE__*/React.createElement(TitleArrow, props));
  } else if ('web' === Platform.OS) {
    return /*#__PURE__*/React.createElement("div", {
      style: style,
      onClick: function onClick(e) {
        return updateOrderWeb(key, e);
      }
    }, /*#__PURE__*/React.createElement(TitleLabel, props), /*#__PURE__*/React.createElement(TitleArrow, props));
  } else {
    return /*#__PURE__*/React.createElement(TouchableWithoutFeedback, {
      onPress: function onPress() {
        return updateOrderNative(key);
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: style
    }, /*#__PURE__*/React.createElement(TitleLabel, props), /*#__PURE__*/React.createElement(TitleArrow, props)));
  }
};
export default Title;